export default "__VITE_ASSET__4730c46f__"